import React, { FC } from 'react'
import { Typography, Flex } from 'antd'

const { Text } = Typography

interface LegendDotProps {
  color: string
  label: string
}

const LegendDot: FC<LegendDotProps> = ({ color, label }) => (
  <Flex align='center' gap={4}>
    <div style={{ width: 10, height: 10, borderRadius: '50%', background: color, flexShrink: 0 }} />
    <Text style={{ fontFamily: 'Roboto', fontWeight: 400, fontSize: 14, lineHeight: '22px', color: '#00000073' }}>{label}</Text>
  </Flex>
)

export default LegendDot
